import axios from "./api";

const UserService = {

    /**
     *
     * @param search
     * @param role
     * @param page
     * @param size
     * @returns {Promise<any>}
     * return object looks like this
     * {
     *   "success": true,
     *   "data": {
     *     "current_page": 1,
     *     "data": [
     *       {
     *         "id": 2,
     *         "name": "Davron",
     *         "username": null,
     *         "phone": "881443133",
     *         "email": null,
     *         "email_verified_at": null,
     *         "dob": null,
     *         "prava_raqam": "123",
     *         "google_id": null,
     *         "facebook_id": null,
     *         "github_id": null,
     *         "avatar": null,
     *         "created_at": "2025-07-01T06:30:16.000000Z",
     *         "updated_at": "2025-07-01T06:30:16.000000Z",
     *         "roles": [
     *           {
     *             "id": 2,
     *             "name": "Шафёр",
     *             "guard_name": "web",
     *             "created_at": "2025-07-01T06:25:29.000000Z",
     *             "updated_at": "2025-07-01T06:25:29.000000Z",
     *             "pivot": {
     *               "model_type": "App\\Models\\User",
     *               "model_id": 2,
     *               "role_id": 2
     *             }
     *           }
     *         ]
     *       },
     *       {
     *         "id": 1,
     *         "name": "admin",
     *         "username": "admin",
     *         "phone": "998911157709",
     *         "email": "admin@gmail.com",
     *         "email_verified_at": "2022-01-02T12:04:58.000000Z",
     *         "dob": "2000-10-10",
     *         "prava_raqam": null,
     *         "google_id": null,
     *         "facebook_id": null,
     *         "github_id": null,
     *         "avatar": "images/avatar-1.jpg",
     *         "created_at": "2025-07-01T06:25:30.000000Z",
     *         "updated_at": "2025-07-01T06:25:30.000000Z",
     *         "roles": [
     *           {
     *             "id": 1,
     *             "name": "Admin",
     *             "guard_name": "web",
     *             "created_at": "2025-07-01T06:25:29.000000Z",
     *             "updated_at": "2025-07-01T06:25:29.000000Z",
     *             "pivot": {
     *               "model_type": "App\\Models\\User",
     *               "model_id": 1,
     *               "role_id": 1
     *             }
     *           }
     *         ]
     *       }
     *     ],
     *     "first_page_url": "http://192.168.0.101:8000/api/user?page=1",
     *     "from": 1,
     *     "last_page": 1,
     *     "last_page_url": "http://192.168.0.101:8000/api/user?page=1",
     *     "links": [
     *       {
     *         "url": null,
     *         "label": "&laquo; Previous",
     *         "active": false
     *       },
     *       {
     *         "url": "http://192.168.0.101:8000/api/user?page=1",
     *         "label": "1",
     *         "active": true
     *       },
     *       {
     *         "url": null,
     *         "label": "Next &raquo;",
     *         "active": false
     *       }
     *     ],
     *     "next_page_url": null,
     *     "path": "http://192.168.0.101:8000/api/user",
     *     "per_page": 10,
     *     "prev_page_url": null,
     *     "to": 2,
     *     "total": 2
     *   },
     *   "message": "success"
     * }
     */
    async getUserList(search, role, page, size) {
        try {
            const response = await axios.get('/user', {
                params: {
                    search: search,
                    roles: role,
                    page: page,
                    per_page: size,
                }
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting userList';
        }
    },

    /**
     * response looks like this
     * {
     *   "success": true,
     *   "message": "success",
     *   "data": [
     *     {
     *       "id": 1,
     *       "name": "admin",
     *       "guard_name": "web",
     *       "created_at": "2024-01-01T12:00:00Z",
     *       "updated_at": "2024-06-01T10:00:00Z"
     *     }
     *   ]
     * }
     * @returns {Promise<any>}
     */
    async getUserRoles() {
        try {
            const response = await axios.get('/role');
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting user roles';
        }
    },
    async getUserById(id) {
        try {
            const response = await axios.get('/user/' + id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error getting user by id';
        }
    },

    async createUser(formData) {
        try {
            const response = await axios.post('/user', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating user';
        }
    },
    async updateUser(formData, id) {
        try {
            const response = await axios.post('/user/' + id+ '?_method=PUT', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                },
            });
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating ijara';
        }
    },
    async deleteUser(id) {
        try {
            const response = await axios.delete('/user/' + id);
            return response.data;
        } catch (error) {
            throw error.response?.data?.message || 'Error updating ijara';
        }
    },

}

export default UserService